<div class="impersonation-logs-content">
  <div class="logs-toolbar">
    <div class="filter-group">
      <label class="filter-label">Performed By</label>
      <select class="form-select form-select-sm" [(ngModel)]="selectedRealUserId" (ngModelChange)="onFilterChange()">
        <option [ngValue]="null">All</option>
        @for (user of impersonators; track user.UserId) {
          <option [ngValue]="user.UserId">{{ user.Name }}</option>
        }
      </select>
    </div>

    <div class="filter-group">
      <label class="filter-label">Impersonated User</label>
      <select class="form-select form-select-sm" [(ngModel)]="selectedImpersonatedUserId" (ngModelChange)="onFilterChange()">
        <option [ngValue]="null">All</option>
        @for (user of impersonatedUsers; track user.UserId) {
          <option [ngValue]="user.UserId">{{ user.Name }}</option>
        }
      </select>
    </div>

    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearFilters()">Clear</button>

    <button type="button" class="btn btn-icon" (click)="refresh()" title="Refresh">
      <i class="icon-refresh icon-action-blue"></i>
    </button>
  </div>

  @if (loadStatus === ServiceStatus.error) {
    <div class="alert alert-danger">Failed to load impersonation logs. Please try again.</div>
  }

  <kendo-grid
    [data]="gridData"
    [loading]="loadStatus === ServiceStatus.loading"
    [pageSize]="PAGE_SIZE"
    [skip]="gridState.skip ?? 0"
    [sort]="gridState.sort ?? []"
    [pageable]="true"
    [sortable]="true"
    [navigable]="true"
    [scrollable]="'scrollable'"
    (dataStateChange)="onStateChange($event)"
    (cellClick)="openDetail($event.dataItem)"
    class="impersonation-logs-grid">

    <kendo-grid-column field="CreatedDateUTC" title="When" [width]="170">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.CreatedDateUTC | date:'yyyy-MM-dd HH:mm:ss' }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="RealUserName" title="Performed By" [width]="180">
    </kendo-grid-column>

    <kendo-grid-column field="ImpersonatedUserName" title="Impersonated" [width]="180">
    </kendo-grid-column>

    <kendo-grid-column field="HttpMethod" title="Method" [width]="90">
    </kendo-grid-column>

    <kendo-grid-column field="RequestPath" title="Request">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="path-cell">{{ dataItem.RequestPath }}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="StatusCode" title="Status" [width]="90">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="status-badge" [ngClass]="getStatusClass(dataItem.StatusCode)">{{ dataItem.StatusCode }}</span>
      </ng-template>
    </kendo-grid-column>

  </kendo-grid>
</div>
